import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tw-w-full tw-border-b tw-border-slate-200/60 tw-bg-white/50 tw-backdrop-blur-md tw-py-3 tw-px-4" }
const _hoisted_2 = { class: "tw-flex tw-flex-col lg:tw-flex-row lg:tw-items-center tw-gap-4" }
const _hoisted_3 = { class: "tw-flex-1 tw-min-w-0" }
const _hoisted_4 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_5 = { class: "tw-flex-shrink-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"tw-flex-shrink-0\"><div class=\"tw-flex tw-items-center tw-gap-2\"><h1 class=\"tw-text-xl tw-font-bold tw-tracking-tight tw-text-slate-800\">Tracking</h1><span class=\"tw-inline-flex tw-items-center tw-rounded-full tw-bg-emerald-100 tw-px-2 tw-py-0.5 tw-text-[10px] tw-font-medium tw-text-emerald-700\">Live</span></div><div class=\"tw-text-xs tw-text-slate-500\">Manage your fleet in real-time</div></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "search")
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Button, {
          variant: "secondary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('refresh')))
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createTextVNode(" Refresh ", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_Button, {
          variant: "secondary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toggleAppointments'))),
          class: "tw-whitespace-nowrap"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(!_ctx.isShowingAppointments ? 'Show appointments' : 'Hide appointments'), 1)
          ]),
          _: 1
        }),
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "tw-hidden lg:tw-block tw-h-6 tw-w-px tw-bg-slate-200 tw-mx-1" }, null, -1)),
        _createElementVNode("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "actions")
        ])
      ])
    ])
  ]))
}